import { render, staticRenderFns } from "./BindGoogle.vue?vue&type=template&id=70f6fea8&scoped=true&"
import script from "./BindGoogle.vue?vue&type=script&lang=js&"
export * from "./BindGoogle.vue?vue&type=script&lang=js&"
import style0 from "./BindGoogle.vue?vue&type=style&index=0&id=70f6fea8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f6fea8",
  null
  
)

export default component.exports